const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
console.log('ESITEEEEE???',API_BASE_URL);
console.log('ESITEEEEE KEYYYYSS???',process.env.SUPABASE_ANON_KEY);


const buildApiUrl = (path) => {
  if (!API_BASE_URL) {
    return path;
  }

  return `${API_BASE_URL}${path}`;
};

const readJson = async (response) => {
  const text = await response.text();

  try {
    return JSON.parse(text);
  } catch {
    throw new Error(`Server returned non-JSON response: ${text.slice(0, 120)}`);
  }
};

const apiFetch = async (path, options) => {
  const response = await fetch(buildApiUrl(path), options);
  const result = await readJson(response);

  if (!response.ok) {
    throw new Error(result.message || "Request failed.");
  }

  return result;
};

export { apiFetch, buildApiUrl };
